module.exports = __webpack_public_path__ + "img/search_result.f2891249.png";